import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';

import { sagaApiGen } from 'utils/sagaApiGeneratorHelpers';

import { userModalActions } from './userModal.actions';
import { readCompanies } from './userModal.api';
import type { ReadCompaniesResponse } from './userModalApi.types';

// Saga
export const userModalSagas = [
  takeLatest(
    userModalActions.companies.get.type,
    sagaApiGen(
      readCompanies,
      userModalActions.companies.fulfilled,
      userModalActions.companies.rejected,
    ),
  ),

  // TODO [TEAMS-6857]: When RTK Q is ready, this function should be replaced with RTK thunk
  // and "companies select" in "userModal" should be paginated/infinite scrolled

  // Recursive get all companies.
  takeEvery(
    userModalActions.companies.fulfilled.type,
    function* ({
      payload,
    }: ReturnType<typeof userModalActions.companies.fulfilled>) {
      const nextPageUrl = payload?.meta?.next_page;
      if (nextPageUrl !== null) {
        try {
          const response: ReadCompaniesResponse = yield call(
            readCompanies,
            nextPageUrl,
          );
          yield put(userModalActions.companies.fulfilled(response));
        } catch (e) {
          yield put(userModalActions.companies.rejected(e as Error));
        }
      }
    },
  ),
];
